import { render, staticRenderFns } from "./SharedKnowledge.vue?vue&type=template&id=9e1ed136&scoped=true"
import script from "./SharedKnowledge.vue?vue&type=script&lang=js"
export * from "./SharedKnowledge.vue?vue&type=script&lang=js"
import style0 from "./SharedKnowledge.vue?vue&type=style&index=0&id=9e1ed136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1ed136",
  null
  
)

export default component.exports